import sanitize, { IOptions } from 'sanitize-html';

import { removePlaceholderParagraphs } from 'app/utils/htmlSanitizer';

import { SanitizationProfileType } from './sanitizeHtml.types';
import { mergeSanitizationProfiles } from './utils/mergeSanitizationProfiles/mergeSanitizationProfiles';
import { sanitizationProfiles } from './utils/sanitizationProfiles/sanitizationProfiles';

/**
 * Returns sanitized HTML based on sanitization profile.
 *
 * @param html The HTML to sanitize.
 * @param profileType The profile type.
 */
export function sanitizeHtml(
  html: string,
  profileType: SanitizationProfileType,
): string {
  const profile = getSanitizationProfile(profileType);
  return removePlaceholderParagraphs(sanitize(html, profile));
}

/**
 * Gets the sanitization profile with highlighting support.
 *
 * We add `<em class="highlight">` to the profile as the search api uses this
 * tag to wrap the matched content based on the search query.
 *
 * @param type The profile type.
 */
function getSanitizationProfile(type: SanitizationProfileType): IOptions {
  return mergeSanitizationProfiles(sanitizationProfiles[type], {
    allowedTags: ['em'],
    allowedClasses: {
      em: ['highlight'],
    },
  });
}
